import { render, staticRenderFns } from "./NotFoundProfessionTaskList.vue?vue&type=template&id=1b9ee6e8&scoped=true"
import script from "./NotFoundProfessionTaskList.vue?vue&type=script&lang=js"
export * from "./NotFoundProfessionTaskList.vue?vue&type=script&lang=js"
import style0 from "./NotFoundProfessionTaskList.vue?vue&type=style&index=0&id=1b9ee6e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9ee6e8",
  null
  
)

export default component.exports